import { useContext } from 'react';
import { StyleSheet, Text, View } from "react-native";
import { useDispatch, useSelector } from 'react-redux';
import { colorNames } from "styles/shared";

import { getLangTerm } from "lang";
import { DetailsPageContext } from './DetailsPageContext';
import PurchaseButtons from '../../shared/PurchaseButtons';
import { getRouteColor } from '../../../styles/shared';
import { getRouteButtonTextColor } from "utils/purchases";

const styles = StyleSheet.create({
    container: {
        maxWidth: 800,
        marginHorizontal: 10,

    },
    borderContainer: {
        borderRadius: 8,
        marginBottom: -22,
        backgroundColor: colorNames.actionGreen
    },
    containerInner: {
        // flexDirection: "row",
        alignItems: "center",
        marginBottom: 8,
        backgroundColor: "#fff",
        borderRadius: 10,
        borderWidth: 2,
        borderColor: colorNames.actionGreen,
        padding: 12,
        fontSize: 14
    },
    header: {
        paddingTop: 6,
        height: 52,
    },
    headerText: {
        textAlign: "center",
        fontSize: 16,
        fontFamily: "bold",
        color: "#FFF"
    },
    contentText: {
        fontSize: 14,
        marginBottom: 10
    }
});

const FreePreview = () => {

    const lang = useSelector(state => state.settings.lang);
    const selectedRouteData = useSelector(state => state.mapData.selectedRouteData);

    const {

        detailsPageData,
        isPremium,
        isPurchased,
    } = useContext(DetailsPageContext);


    const { slug } = detailsPageData;
    const { slug: routeSlug, title } = selectedRouteData;
    const headerColor = getRouteButtonTextColor(routeSlug);

    if (!isPremium || isPurchased || (slug !== "steam-clock" && slug !== "nine-o-clock-gun-stanley-park")) {
        return null;

    }

    return <View style={styles.container}>
        <View style={{
            ...styles.borderContainer,
            backgroundColor: getRouteColor(routeSlug)
        }}>
            <View style={styles.header}>
                <Text style={{
                    ...styles.headerText,
                    color: headerColor
                }}>{getLangTerm("free-preview", lang)}</Text>
            </View>
        </View>
        <View style={{
            ...styles.containerInner,
            borderColor: getRouteColor(routeSlug)
        }}>
            <View >
                <Text style={styles.contentText}>{getLangTerm("free-preview-details", lang).replace("||title||", title)}</Text>
            </View>
            <PurchaseButtons route={selectedRouteData} />
        </View>
    </View>
}

export default FreePreview;